angular.module('shared').factory('TableService', ["ngTableParams", function(ngTableParams) {
  return {
    init: function(params) {
      var tableData;
      tableData = {};
      return new ngTableParams({
        page: 1,
        count: params.count || 25,
        filters: params.filters,
        order: params.order,
        filterDelay: params.filterDelay
      }, {
        counts: [],
        total: 0,
        getData: function($defer, $params) {
          var beforeLoad, query, resolve;
          query = $params.url();
          beforeLoad = function(queryParams) {
            var current, prev;
            prev = _.omit(tableData.prevQuery, 'page');
            current = _.omit(queryParams, 'page');
            if (tableData.prevQuery && !_.isEqual(prev, current) && (tableData.prevQuery.page === queryParams.page)) {
              return $params.page(1);
            }
            return tableData.prevQuery = queryParams;
          };
          resolve = function(items) {
            $defer.resolve(items);
            if (!items.length && tableData.prevQuery && tableData.prevQuery.page > 1) {
              return $params.page(tableData.prevQuery.page - 1);
            }
          };
          return params.getData(resolve, $params, beforeLoad);
        }
      });
    }
  };
}]);
